import * as React from "react";
import {useMemo} from "react";
import {CartesianGrid, Legend, Line, LineChart, ResponsiveContainer, Tooltip, XAxis, YAxis} from "recharts";
import {IEngagementTabResponse} from "../../../../api/AdminAnalyticsApi";
import {formatMonthLabel} from "../shared/analytics.format";
import {
    axisTickStyle,
    chartColors,
    gridProps,
    gridStroke,
    legendStyle,
    tooltipStyle,
} from "../shared/analytics.constants";

interface IAreaTrendsChartProps {
    areaTrends: IEngagementTabResponse["areaTrends"];
}

export const AreaTrendsChart: React.FC<IAreaTrendsChartProps> = ({areaTrends}) => {
    const areaTrendData = useMemo(() => {
        const monthSet = new Set<string>();
        areaTrends.forEach((row) => row.monthly.forEach((point) => monthSet.add(point.month)));
        const months = Array.from(monthSet).sort();
        return months.map((month) => {
            const item: { [key: string]: string | number } = {month: formatMonthLabel(month)};
            areaTrends.forEach((trend) => {
                const value = trend.monthly.find((p) => p.month === month)?.visits ?? 0;
                item[trend.area] = value;
            });
            return item;
        });
    }, [areaTrends]);

    return (
        <div>
            <h3 className="admin-analytics__subsection-title" style={{marginTop: 20}}>Top Areas Over
                Time</h3>
            <div className="admin-analytics__chart">
                <ResponsiveContainer width="100%" height={280}>
                    <LineChart data={areaTrendData}>
                        <CartesianGrid {...gridProps} />
                        <XAxis dataKey="month" tick={axisTickStyle} axisLine={{stroke: gridStroke}}
                               tickLine={false}/>
                        <YAxis tick={axisTickStyle} axisLine={false} tickLine={false}/>
                        <Tooltip {...tooltipStyle} />
                        <Legend {...legendStyle} />
                        {areaTrends.map((trend, index) => (
                            <Line
                                key={trend.area}
                                type="monotone"
                                dataKey={trend.area}
                                stroke={[
                                    chartColors.tealDark, chartColors.navy, chartColors.tealLight,
                                    chartColors.peacock, chartColors.gray02, chartColors.gray03,
                                ][index % 6]}
                            />
                        ))}
                    </LineChart>
                </ResponsiveContainer>
            </div>
        </div>
    );
};
